import theme from '@/config/theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  setNameBox: {
    padding: 20,
    backgroundColor: theme.colors.lightBlue,
    borderRadius: theme.borderRadii.xl,
    alignSelf: 'flex-start',
    marginTop: 20,
    marginLeft: 20,
  },
  boxWrapper: {
    padding: 10,
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleBox: {
    paddingBottom: theme.spacings.xl,
    paddingHorizontal: 20,
    paddingTop: 20,
  },
  buttonWrapper: {
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
});
